import React, { Component } from 'react';
import feed from "../assets/json/feed"; 
//import Tree from "../tree";
import Node from "../node";

export default class ISWidget extends Component{

	constructor(){
		super();
		let metas = document.getElementsByTagName("meta");
		/*
		metas.forEach((meta, i)=>{
			if(meta.name==="viewport"){
				alert(meta.content);
			}
		});
		*/
		for(let i=0; i<metas.length; i++){
			if(metas[i].name==="viewport"){
				//alert(metas[i].content);
			}
		}

		this.state={
			node:new Node(feed.topic, feed.information, feed.url, null, feed.topics),
			open:true
		}
	}

	setNode=(child)=>{
		if(child){
			this.setState({node:child});
		}
	}

	minificar=()=>{

		console.log("minificar");
		let _open=this.state.open;
		if(_open===true){
			_open=false;
		}else{
			_open=true;
		}
		this.setState({open:_open});
	}

	render = () => {
		let children=this.state.node.getChildren();
		let information=this.state.node.getInformation();
		let url=this.state.node.getUrl();
		let parent=this.state.node.getParent();

		let root=new Node(feed.topic, feed.information, feed.url, null, feed.topics);

		if(this.state.open===true){
			if(parent===null){
				return (<div>

							<p className="app-nav">
								<button className="app-nav-min" onClick={this.minificar.bind(this)}></button>
							</p>
							
							<p>{this.state.node.getInformation()}</p>
							<div>
								<ul>
									{children.map((child, i) => <li key={i}><button data-child={child}  onClick={() => this.setNode(child)}>{child.getTopic()}</button></li>)}
								</ul>
							</div>
						</div>);
			}else{
				if(url!==""){
					return (<div>
							
							<p className="app-nav">
								<button className="app-nav-start" data-parent={parent} onClick={() => this.setNode(parent)}>Regresar</button>
								<button className="app-nav-back" data-parent={root} onClick={() => this.setNode(root)}>Inicio</button>
								<button className="app-nav-min" onClick={this.minificar.bind(this)}></button>
							</p>
							<div>{information.map((info, k)=><p key={k}>{info}</p>)}</div>
							<div><p className="artitle-link"><a href={url}>Ver más</a></p></div>	
							<div>
								<ul>
									{children.map((child, i) => <li key={i}><button data-child={child}  onClick={() => this.setNode(child)}>{child.getTopic()}</button></li>)}
								</ul>
							</div>
						</div>);
				}else{
					return (<div>
							
							<p className="app-nav">
								<button className="app-nav-start" data-parent={parent} onClick={() => this.setNode(parent)}>Regresar</button>
								<button className="app-nav-back" data-parent={root} onClick={() => this.setNode(root)}>Inicio</button>
								<button className="app-nav-min" onClick={this.minificar.bind(this)}></button>
							</p>
							<div>{information.map((info, k)=><p key={k}>{info}</p>)}</div>
							<div>
								<ul>
									{children.map((child, i) => <li key={i}><button data-child={child}  onClick={() => this.setNode(child)}>{child.getTopic()}</button></li>)}
								</ul>
							</div>
						</div>);
				}
				
			}

		}else{
			return (<div>
						<p className="app-nav">
							<button className="app-nav-max" onClick={this.minificar.bind(this)}></button>
						</p>
					</div>);
		}
	}

}